import brokerAngel from '../resources/brand/broker-angel.png';
import brokerUpstox from '../resources/brand/broker-upstox.svg';
import brokerFinvasia from '../resources/brand/broker-finvasia.png';
import brokerIifl from '../resources/brand/broker-iifl.svg';

export const brokerWiseAppBrokerList = [
  {
    name: 'angel',
    displayName: 'Angel One',
    loginPage: 'https://app.quantiply.angelone.in',
    logo: brokerAngel,
  },
  {
    name: 'upstox',
    displayName: 'Upstox',
    loginPage: 'https://quantiply.upstox.com',
    logo: brokerUpstox,
  },
  {
    name: 'finvasia',
    displayName: 'Finvasia',
    loginPage: 'https://quantiply.shoonya.com',
    logo: brokerFinvasia,
  },
  {
    name: 'iifl-markets',
    displayName: 'IIFL',
    loginPage: 'https://quantiply.iiflcapital.com',
    logo: brokerIifl,
  },
];
